import { env } from '@/env/env';
import axios from 'axios';

export const getHeaders = () => {
  const headers: Record<string, string> = {
    'Content-Type': 'application/json;charset=UTF-8'
  };

  return { headers };
};

export const api = axios.create({
  baseURL: env.VITE_MOCK_MODE ? '/' : (env.VITE_SHIPLEX_BASE_URL ?? '/')
});

let clerkGetToken: (() => Promise<string | null>) | null = null;

export const setClerkTokenGetter = (getter: () => Promise<string | null>) => {
  clerkGetToken = getter;
};

api.interceptors.request.use(async (config) => {
  if (clerkGetToken) {
    try {
      const token = await clerkGetToken();
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
    } catch (error) {
      console.error('Error getting Clerk token:', error);
    }
  }

  return config;
});

export const CACHE_TIME = {
  STALE: 5 * 60 * 1000,
  GC: 10 * 60 * 1000
} as const;
